<!-- @format -->

<ng-container *transloco="let t">
  @if (this.studentWorkflow) {
    <div data-cy="prior-learning-workflow-student-view">
      <fudis-grid [rowGap]="'md'">
        <fudis-grid-item>
          <div class="d-flex flex-column flex-sm-row justify-content-end gap-4">
            @if (isSubstitutionWorkflow()) {
              <fudis-button
                [label]="t('STUDENT_APPLICATIONS.SHOW_COURSE_UNIT_INFO')"
                [variant]="'tertiary'"
                [icon]="'brochure'"
                (handleClick)="openCourseUnitInfoModal()"
                data-cy="plw-course-unit-info-button" />
            }
            @if (isSupplementRequested()) {
              <fudis-button
                [label]="t('PROFILE.APPLICATIONS.SUPPLEMENT.SUPPLEMENT_APPLICATION')"
                [variant]="'secondary'"
                (handleClick)="goToSupplementWizard()"
                data-cy="plw-supplement-button" />
            }
            @if (isWorkflowRequested() || isWorkflowInHandling() || isSupplementRequested()) {
              <fudis-button
                [label]="t('PROFILE.APPLICATIONS.CANCEL_APPLICATION_MODAL.BUTTON.OPEN_CANCEL_APPLICATION_MODAL')"
                (handleClick)="openCancelDialog()"
                data-cy="plw-cancel-button" />
            }
          </div>
        </fudis-grid-item>
      </fudis-grid>
      <fudis-grid [classes]="'fudis-mt-sm'" [rowGap]="'sm'">
        @if (isWorkflowRequested()) {
          <fudis-notification [variant]="'warning'">
            <fudis-body-text>
              {{ t("PROFILE.APPLICATIONS.ATTACHMENT_DELIVERY_REMINDER") }}
            </fudis-body-text>
          </fudis-notification>
        }
        @if (isSupplementRequested() && this.supplementRationale$ | async; as supplementRationale) {
          <fudis-notification [variant]="'warning'">
            <fudis-body-text>{{ t("PROFILE.APPLICATIONS.SUPPLEMENT_REQUESTED_RATIONALE") }}</fudis-body-text>
            <fudis-body-text>{{ supplementRationale }}</fudis-body-text>
          </fudis-notification>
        }
        @if (isInitiatedByStaff()) {
          <fudis-notification [variant]="'info'">
            <fudis-body-text>
              {{ t("PROFILE.APPLICATIONS.APPLICATION_CREATED_BY_STAFF") }}
            </fudis-body-text>
          </fudis-notification>
        }
        @if (isWorkflowCancelled()) {
          <fudis-body-text [variant]="'md-light'">
            {{ t("PROFILE.APPLICATIONS.APPLICATION_CANCELLED") }}
          </fudis-body-text>
        }
        @if (isInclusionWorkflow() && inclusionApplicationInstruction$ | async; as inclusionApplicationInstruction) {
          <sis-localized-markup-string-view class="fudis-body-text__md-light" [content]="inclusionApplicationInstruction" />
        }
        @if (!studentWorkflow.decision) {
          <fudis-grid-item>
            <fudis-heading [level]="2">{{ t("STUDENT_APPLICATIONS.APPLICATION_INFO") }}</fudis-heading>
            @if (studentWorkflow) {
              <app-prior-learning-workflow-content
                [priorLearningWorkflow]="studentWorkflow"
                (openCourseUnitInfoModal)="openCourseUnitInfoModal()">
              </app-prior-learning-workflow-content>
            }
          </fudis-grid-item>
        }
        @if (studentWorkflow.decision) {
          <fudis-grid-item>
            <fudis-expandable [level]="2" [title]="t('STUDENT_APPLICATIONS.APPLICATION_INFO')">
              <ng-template fudisExpandableContent>
                @if (studentWorkflow) {
                  <app-prior-learning-workflow-content
                    [priorLearningWorkflow]="studentWorkflow"
                    (openCourseUnitInfoModal)="openCourseUnitInfoModal()">
                  </app-prior-learning-workflow-content>
                }
              </ng-template>
            </fudis-expandable>
            <fudis-expandable [title]="t('STUDENT_APPLICATIONS.DECISION_INFO')" [level]="2" [closed]="false">
              <ng-template fudisExpandableContent>
                <sis-attainment-workflow-decision-summary
                  [workflowDecision]="studentWorkflow.decision"
                  [workflowState]="studentWorkflow.state"
                  [workflowType]="studentWorkflow.type"
                  [attainment]="activeAttainment" />
              </ng-template>
            </fudis-expandable>
          </fudis-grid-item>
        }
      </fudis-grid>
    </div>
  }
</ng-container>
